var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.592 13.2068C11.281 13.2068 14.434 13.7658 14.434 15.9988C14.434 18.2318 11.302 18.8068 7.592 18.8068C3.902 18.8068 0.75 18.2528 0.75 16.0188C0.75 13.7848 3.881 13.2068 7.592 13.2068Z",
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58913 10.0198C5.16713 10.0198 3.20312 8.05676 3.20312 5.63476C3.20312 3.21276 5.16713 1.24976 7.58913 1.24976C10.0101 1.24976 11.9741 3.21276 11.9741 5.63476C11.9831 8.04776 10.0331 10.0108 7.62012 10.0198H7.58913Z",
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4844 8.88153C16.0854 8.65653 17.3184 7.28253 17.3214 5.61953C17.3214 3.98053 16.1264 2.62053 14.5594 2.36353",
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 12.7322C18.1447 12.9632 19.2278 13.5072 19.2278 14.6272C19.2278 15.3982 18.7177 15.8982 17.8937 16.2112",
    stroke: "#383E49",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.10d620b9627f58f8a58be74c9ed3cbdc.svg";
export { ForwardRef as ReactComponent };